export type IOfficeReadyInfo = Awaited<ReturnType<typeof Office.onReady>>;

const DEFAULT_OFFICE_READY_TIMEOUT_MS = 20_000;

let cachedInfo: IOfficeReadyInfo | null = null;
let pending: Promise<IOfficeReadyInfo> | null = null;

export function isOfficeJsLoaded(): boolean
{
    return typeof Office !== 'undefined' && typeof Office?.onReady === 'function';
}

export function getCachedOfficeInfo(): IOfficeReadyInfo | null
{
    return cachedInfo;
}

export function awaitOfficeReady(timeoutMs: number = DEFAULT_OFFICE_READY_TIMEOUT_MS): Promise<IOfficeReadyInfo>
{
    if (cachedInfo)
    {
        return Promise.resolve(cachedInfo);
    }

    if (!isOfficeJsLoaded())
    {
        return Promise.reject(new Error('office.js is not loaded (Office global missing)'));
    }

    if (!pending)
    {
        let timeoutId: ReturnType<typeof setTimeout> | undefined;

        const timeout = new Promise<never>((_, reject) =>
        {
            timeoutId = setTimeout(
                () => reject(new Error(`Office.onReady() timed out after ${ timeoutMs }ms`)),
                timeoutMs,
            );
        });

        pending = Promise.race([ Office.onReady(), timeout ])
            .then((info) =>
            {
                cachedInfo = info;
                return info;
            })
            .finally(() =>
            {
                if (timeoutId !== undefined)
                {
                    clearTimeout(timeoutId);
                }
                pending = null;
            });
    }

    return pending;
}
